The geoLocation coordinates input used for the location suggestions.
